import { apiAxios } from '@/lib/apiAxios';
import { format } from 'date-fns';
import { DATE_FORMAT_ISO } from '@/constants/date';
export const updateWorkspace = async ({ workspaceId, data }) => apiAxios
    .post(`/workspaces/${workspaceId}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => response.data);
export const fetchWorkspaceBotInfo = async (workspaceId) => apiAxios
    .get(`/workspaces/${workspaceId}/telegram/bot-info`)
    .then((response) => response.data);
export const sendWorkspaceTelegramTest = async ({ workspaceId, chatId, }) => apiAxios
    .post(`/workspaces/${workspaceId}/telegram/test`, { chatId })
    .then((response) => response.data);
export const fetchMembers = async (workspaceId) => apiAxios.get(`/workspaces/${workspaceId}/members`).then((response) => response.data);
export const promoteMember = async ({ workspaceId, memberId, role, }) => apiAxios
    .patch(`/workspaces/${workspaceId}/members/${memberId}/promote`, { role })
    .then((response) => response.data);
export const deleteMember = async ({ workspaceId, memberId }) => apiAxios.delete(`/workspaces/${workspaceId}/members/${memberId}`).then((response) => response.data);
export const fetchInvites = async (workspaceId) => apiAxios.get(`/workspaces/${workspaceId}/invites`).then((response) => response.data);
export const inviteMember = async ({ workspaceId, data }) => apiAxios.post(`/workspaces/${workspaceId}/invites`, data).then((response) => response.data);
export const revokeInvite = async ({ workspacePublicId, invitePublicId, }) => await apiAxios
    .delete(`/workspaces/${workspacePublicId}/invites/${invitePublicId}/revoke`)
    .then((response) => response.data);
export const fetchWorkspaceAnalytics = async ({ workspaceId, from, to, excludeDevices, excludeBrowsers, }) => apiAxios
    .get(`/workspaces/${workspaceId}/analytics`, {
    params: {
        from: format(from, DATE_FORMAT_ISO),
        to: format(to, DATE_FORMAT_ISO),
        'excludeDevices[]': excludeDevices,
        'excludeBrowsers[]': excludeBrowsers,
    },
})
    .then((response) => response.data);
